import { useMemo } from 'react'

import { toCourseSummary } from './coursePresentation'
import { useUser } from '../../context'

import type { CourseSummary } from '../pages/Dasboard/_components/types'

export const useCourseSummaries = () => {
  const { loadingUser, user } = useUser()

  const courses = useMemo<CourseSummary[]>(
    () => (user?.courses ?? []).map(toCourseSummary),
    [user?.courses],
  )

  return {
    courses,
    loading: loadingUser,
  }
}
